<div style="margin:20px">
    <p style="font-size: 24px;">Un-Authorized Access!</p>
    <p>
        You are not authorized to access this part of application, Please contact the application administrator to get the access.</p>
    <a href="javascript: void(0);" [routerLink]="['dashboard']">Go To Dashboard</a>

</div>